import styled from 'styled-components'
import tw from 'twin.macro'

export const LookBooksAndGuides = styled.div`
  ${tw`grid md:grid-cols-2 gap-x-16 gap-y-8 px-insetX my-insetY ta-max-width`};
`

export const PopularTags = styled.div`
  ${tw`text-center px-insetX py-insetY`};
`

export const Articles = styled.div``

export const Columns = styled.div`
  ${tw`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8`};
`

export const Column = styled.div``

export const List = styled.div`
  ${tw`grid gap-8`};
`

export const FeaturedArticles = styled.div`
  ${tw`py-6 lg:py-12 px-insetX border-t border-b ta-max-width-parent`};
  color: var(--color-gold-black);
  background-color: var(--color-gold-white);
  border-color: var(--color-gold-white-line);
`

export const Main = styled.div`
  ${tw`px-insetX py-insetY grid lg:grid-flow-col-dense gap-8 ta-max-width`};
`

export const Filter = styled.div`
  ${tw`lg:pr-8`};
  border-right: solid 1px var(--color-grey);
`
